import { compact } from 'lodash-es';
import { LEAD_TARGETS_API_URL_LEAD_BUSINESS } from 'site-modules/shared/constants/lead-form/lead-form-configs';

export function buildLeadTargetsApiUrl({
  make,
  model,
  year,
  styleId,
  omitStyleId,
  omitYear,
  strategy,
  zipCode,
  latitude,
  longitude,
  dma,
  radius,
  stateCode,
  vin,
  leadTargetsSize,
  isPickup,
  apiSubModel,
  encodedTrim,
  withLeasePayment = '',
  targetGroups,
}) {
  const queryParams = compact([
    `strategy=${strategy}`,
    `&size=${leadTargetsSize}`,
    !omitStyleId && `&styleId=${styleId}`,
    `&trim=${encodedTrim}`,
    `&selectedVin=${vin}`,
    `&zip=${zipCode}`,
    `&lat=${latitude}`,
    `&lon=${longitude}`,
    `&userDma=${dma}`,
    `&radius=${radius}`,
    `&userState=${stateCode}`,
    `&make=${make}`,
    `&model=${model}`,
    `&submodel=${apiSubModel}`,
    !omitYear && `&year=${year}`,
    `&fields=dealerInfo(productFeatures,name,partnerCode,franchiseId,rooftopId,address(city,stateName,stateCode,street),displayInfo(salesOverallRating,salesReviewCount,parentDealershipName),phoneNumbers),stockNumber,vehicleInfo(partsInfo(engineType),photo(defaultPhoto(small,large)),styleInfo(bodyType,make,model,year,trim,styleId,style${
      isPickup ? ',manufacturerCabType,vehicleStyle' : ''
    }),vehicleColors,mileage),type,vin,vid,inTransit,prices(advertisedPrice,displayPrice,totalMsrp,baseMsrp,destinationFee${withLeasePayment},destinationFeeIsCompliant,dealerMsrpStrikethroughIsCompliant,edmundsSuggestedPriceIsCompliant,advertisedPriceSource,dealerMsrp,edmundsSuggestedPrice),computedInfo,deliveryOptions(deliveryCode)`,
    targetGroups && `&targetGroups=${targetGroups}`,
  ]).join('');
  return `${LEAD_TARGETS_API_URL_LEAD_BUSINESS}?${queryParams}`;
}
